import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/index.vue';
import OneGC from '../views/onegc/onegc.vue';
import store from '../store';
import en from './../locales/en.json';

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
VueRouter.prototype.replace = function push(location) {
  return originalReplace.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'home',
    meta: { layout: 'app' },
    component: Home
  },
  {
    path: '/onegc',
    name: 'onegc',
    meta: { layout: 'auth' },
    component: OneGC
  },
  {
    path: '/account',
    name: 'account',
    component: () => import(/* webpackChunkName: "account" */ '../views/account/account.vue'),
    meta: { layout: 'app' }
  },
  {
    path: '/material',
    name: 'material',
    component: () => import(/* webpackChunkName: "material" */ '../views/material/material.vue'),
    meta: { layout: 'app' }
  },
  {
    path: '/record',
    name: 'record',
    component: () => import(/* webpackChunkName: "record" */ '../views/record/record.vue'),
    meta: { layout: 'app' }
  },

  /**
   * 错误页面
   */
  {
    path: '/pages/error404',
    name: 'error404',
    component: () => import(/* webpackChunkName: "pages-error404" */ '../views/pages/error404.vue'),
    meta: { layout: 'auth' }
  },
  {
    path: '/pages/error500',
    name: 'error500',
    component: () => import(/* webpackChunkName: "pages-error500" */ '../views/pages/error500.vue'),
    meta: { layout: 'auth' }
  },
  {
    path: '/pages/error503',
    name: 'error503',
    component: () => import(/* webpackChunkName: "pages-error503" */ '../views/pages/error503.vue'),
    meta: { layout: 'auth' }
  },

  /**
   * 登录
   */
  {
    path: '/auth/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "auth-login" */ '../views/auth/login.vue'),
    meta: { layout: 'auth', title: '登录' }
  },

];

const router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: 'active',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.layout && to.meta.layout == 'auth') {
    store.commit('setLayout', 'auth');
  } else {
    store.commit('setLayout', 'app');
  }
  try {
    if (document.getElementById('content')) {
      document.getElementById('content').scrollTop = 0
    }
  } catch (error) {
    console.log(error);
  }
  if (routes.map(item => item.path).includes(to.path)) {
    next(true);
  } else {
    next({ name: 'error404' });
  }
});

router.afterEach((to) => {
  // console.log(to)
  let title = '';
  if (to.meta && to.meta.title) {
    title = to.meta.title;
    if (store.getters.locale == 'en') {
      title = en[title];
    }
  }
  title = title || 'Home';
  document.title = title + ' | OneGC';
})

export default router;
